var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0703 14.1016C11.8594 14.3125 11.8594 14.6641 12.0703 14.875L16.6172 19.4453C16.8516 19.6562 17.2031 19.6562 17.4141 19.4453L17.9531 18.9062C18.1641 18.6953 18.1641 18.3437 17.9531 18.1094L14.3438 14.5L17.9531 10.8672C18.1641 10.6328 18.1641 10.2812 17.9531 10.0703L17.4141 9.53125C17.2031 9.32031 16.8516 9.32031 16.6172 9.53125L12.0703 14.1016Z",
    fill: "#363ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon-left-arrow.b21b2223d85454821350c75aeff68d67.svg";
export { ForwardRef as ReactComponent };